import { Navigate, Outlet } from 'react-router-dom';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import Loading from 'src/components/ui/Loading';

interface FeatureFlagGuardProps {
  flagKey: string;
  redirectTo?: string;
}

export default function FeatureFlagGuard({ flagKey, redirectTo = '/home' }: FeatureFlagGuardProps) {
  const isEnabled = useFeatureFlag(flagKey);

  if (isEnabled === undefined) {
    return <Loading fullscreen />;
  }

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
